import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import type { ScorePedagogicoFilters as FiltersType } from '../types';
import { useSeries } from '@/features/list-serie/api/getSerie';
import { useTurmas } from '@/features/list-turma/api/getTurma';
import ListItems from '@/components/Base/ListItems';

interface Props {
  filters: FiltersType;
  onFilterChange: (filters: FiltersType) => void;
}

const ScorePedagogicoFilters: React.FC<Props> = ({ filters, onFilterChange }) => {
  const { data: seriesData } = useSeries();
  const { data: turmasData } = useTurmas(filters.serieNome);

  const seriesOptions = (seriesData ?? []).map((item) => ({
    id: item.serie_nome,
    label: item.serie_nome,
    name: item.serie_nome,
  }));

  const turmasOptions = (turmasData ?? []).map((item) => ({
    id: item.nome,
    label: item.sigla,
    name: item.nome,
  }));

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        display: 'flex',
        gap: '16px',
        alignItems: 'end',
        p: '8px',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        mb: 2,
        mt: 2,
        '.MuiInputBase-input': { padding: '5px', color: '#000' },
        '.MuiButtonBase-root': { color: '#000' },
        '.MuiTypography-root': { color: '#000' },
      }}
    >
      <Box maxWidth="250px" width="100%">
        <ListItems
          name="serie_nome"
          options={seriesOptions}
          label="Série"
          value={filters.serieNome ?? 'all'}
          onChange={(e) => {
            const val = e.target.value === 'all' ? null : e.target.value;
            onFilterChange({ ...filters, serieNome: val, turmaNome: null });
          }}
        />
      </Box>

      <Box maxWidth="250px" width="100%">
        <ListItems
          name="turma_nome"
          options={turmasOptions}
          label="Turma"
          value={filters.turmaNome ?? 'all'}
          onChange={(e) => {
            const val = e.target.value === 'all' ? null : e.target.value;
            onFilterChange({ ...filters, turmaNome: val });
          }}
        />
      </Box>

      <Box maxWidth="130px" width="100%">
        <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth>
          <Typography mb="7px">Ano</Typography>
          <Select
            id="ano"
            name="ano"
            sx={{ color: '#000', border: '1px solid #000' }}
            value={filters.ano}
            onChange={(e) => onFilterChange({ ...filters, ano: Number(e.target.value) })}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value={2025}>2025</MenuItem>
            <MenuItem value={2026}>2026</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default ScorePedagogicoFilters;
